package dev.akshaychordiya.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initAboutPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("About.md", FrontMatterElement.Builder { addScalar("title", "About"); }))
}

@Page("/about")
@Layout(".components.layouts.ProseLayout")
@Composable
fun AboutPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("about") }) {
        org.jetbrains.compose.web.dom.Text("About")
    }
    dev.akshaychordiya.components.widgets.Portrait()
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("I'm Akshay Chordiya - a ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://developers.google.com/community/experts") {
            org.jetbrains.compose.web.dom.Text("Google Developer Expert")
        }
        org.jetbrains.compose.web.dom.Text(" for Android 🤖")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Currently based in UK & worked in 4 countries 🇬🇧🇺🇸🇩🇪🇮🇳 across 3 continents 🌎")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("I've been building Android apps for over a decade. These days that mostly means Jetpack Compose, Kotlin Flow, and the unglamorous work of keeping a large codebase fast and pleasant to work in as more people join it.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("speaking") }) {
        org.jetbrains.compose.web.dom.Text("Speaking")
    }
    dev.akshaychordiya.components.widgets.TalkStats()
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("If you're trying to get your first CFP accepted, that's one of the things I'll happily talk through ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://topmate.io/akshaychordiya") {
            org.jetbrains.compose.web.dom.Text("1:1")
        }
        org.jetbrains.compose.web.dom.Text(".")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("writing") }) {
        org.jetbrains.compose.web.dom.Text("Writing")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("I co-authored ")
        com.varabyte.kobweb.silk.components.navigation.Link("/books") {
            org.jetbrains.compose.web.dom.Text("Kotlin Blueprints")
        }
        org.jetbrains.compose.web.dom.Text(" with Ashish Belagali and Hardik Trivedi, and there's a second book in the works.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Everything I write now lands ")
        com.varabyte.kobweb.silk.components.navigation.Link("/articles") {
            org.jetbrains.compose.web.dom.Text("here first")
        }
        org.jetbrains.compose.web.dom.Text(". The older pieces were on Medium for years; they've moved across.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("side-of-the-desk") }) {
        org.jetbrains.compose.web.dom.Text("Side of the desk")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("I build ")
        com.varabyte.kobweb.silk.components.navigation.Link("/apps") {
            org.jetbrains.compose.web.dom.Text("small apps")
        }
        org.jetbrains.compose.web.dom.Text(" and put them on Google Play - a music player, a lock screen, a pronunciation helper, and a map of neighbourhood cats.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("interests") }) {
        org.jetbrains.compose.web.dom.Text("Interests")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Outside work, the things I'll happily lose an afternoon to:")
    }
    dev.akshaychordiya.components.widgets.Interests()
    org.jetbrains.compose.web.dom.H2(attrs = { id("elsewhere") }) {
        org.jetbrains.compose.web.dom.Text("Elsewhere")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("https://github.com/AkshayChordiya") {
                org.jetbrains.compose.web.dom.Text("GitHub")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("https://www.linkedin.com/in/akshaychordiya/") {
                org.jetbrains.compose.web.dom.Text("LinkedIn")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("https://twitter.com/Akshay_Chordiya") {
                org.jetbrains.compose.web.dom.Text("X")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/@aky") {
                org.jetbrains.compose.web.dom.Text("Medium")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("https://sessionize.com/akshay-chordiya/") {
                org.jetbrains.compose.web.dom.Text("Sessionize")
            }
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("work-with-me") }) {
        org.jetbrains.compose.web.dom.Text("Work with me")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("I do ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://topmate.io/akshaychordiya") {
            org.jetbrains.compose.web.dom.Text("1:1 sessions")
        }
        org.jetbrains.compose.web.dom.Text(" on career, Android and Kotlin, public speaking, and moving abroad as an engineer - plus a free discovery call if you'd rather work out what would help before booking anything.")
    }
}
